export default class BaseReducer<T> {
  dispatch: React.Dispatch<T>;
  constructor(dispatcher: React.Dispatch<T>) {
    this.dispatch = dispatcher;
  }
  static getInitialState(initialState: Object): any {
    return initialState;
  }
  static reducer(state: any, action: any): any {}
}
